import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { COLORS, Text } from '../Basics';
import { useStore } from '../../store/Context';

const formatElapsed = ms => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

const TimeCell = ({ label, value, highlight }) => (
  <View style={{ flex: 1, minWidth: 72, alignItems: 'center' }}>
    <Text style={{ fontSize: 10, color: COLORS.textSecondary }}>{label}</Text>
    <Text
      style={{
        fontSize: 13,
        fontWeight: '600',
        fontVariant: ['tabular-nums'],
        color: highlight ? COLORS.accent : COLORS.textPrimary
      }}
    >
      {value}
    </Text>
  </View>
);

/**
 * Tempos operacionais do ramal — status, chamada, pausa e sessão CTI.
 */
export const ExtensionStatusBar = () => {
  const { status, statuses = [], lorentz = {}, extensionTimers = {} } =
    useStore();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const statusDef = statuses.find(s => s.value === status);
  const statusLabel = statusDef?.text || status;
  const statusSince = extensionTimers.statusSince || now;
  const sessionSince = extensionTimers.sessionSince;
  const callSince = extensionTimers.callSince;
  const pauseSince =
    status !== 'online' ? extensionTimers.pauseSince || statusSince : null;

  const showCti = lorentz?.enabled && lorentz?.authenticated;
  const extension = lorentz?.extension;

  if (!extension && !showCti) return null;

  return (
    <View
      style={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        backgroundColor: COLORS.backColor,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: COLORS.borderColor,
        paddingVertical: 8,
        paddingHorizontal: 6,
        marginBottom: 8
      }}
    >
      {extension ? (
        <TimeCell label="Ramal" value={extension} highlight />
      ) : null}
      <TimeCell
        label={`Status (${statusLabel})`}
        value={formatElapsed(now - statusSince)}
      />
      {callSince ? (
        <TimeCell
          label="Chamada"
          value={formatElapsed(now - callSince)}
          highlight
        />
      ) : null}
      {pauseSince && status !== 'online' ? (
        <TimeCell
          label="Pausa"
          value={formatElapsed(now - pauseSince)}
        />
      ) : null}
      {showCti && sessionSince ? (
        <TimeCell
          label="Sessão CTI"
          value={formatElapsed(now - sessionSince)}
        />
      ) : null}
    </View>
  );
};

export default ExtensionStatusBar;
